<template>

	<v-app>
		<router-view name="main" class="standalone-page"></router-view>
		<router-view name="login" class="standalone-page"></router-view>
		<router-view name="aanmelden" class="standalone-page"></router-view>
		<router-view name="bedankt" class="standalone-page"></router-view>
	</v-app>
</template>

<script>


export default {
	name: "App",
	data: () => ({
		//
	})
};
</script>

<style>
/* Use native browser scrolling - remove all height constraints and overflow restrictions */
html, body {
	height: auto !important;
	min-height: 100vh !important;
	overflow-x: hidden !important;
	overflow-y: auto !important;
}

/* Allow v-application to grow naturally with content */
.v-application {
	min-height: 100vh !important;
	height: auto !important;
	overflow: visible !important;
}

.v-application--wrap {
	min-height: 100vh !important;
	height: auto !important;
	display: flex !important;
	flex-direction: column !important;
	overflow: visible !important;
}

/* Standalone pages - allow natural flow */
.standalone-page {
	min-height: 100vh !important;
	position: relative !important;
}

/* v-content should not restrict height - let content flow naturally */
.v-content {
	flex: 1 1 auto !important;
	overflow: visible !important;
	position: relative !important;
	min-height: auto !important;
	height: auto !important;
}

.v-content__wrap {
	overflow: visible !important;
	position: relative !important;
	min-height: auto !important;
	height: auto !important;
}

/* Navigation drawer should still be scrollable (it's a sidebar) - Vuetify handles positioning with app prop */
.v-navigation-drawer {
	overflow: hidden !important;
}

/* Ensure containers allow content to flow naturally */
.v-container {
	position: relative !important;
	overflow: visible !important;
}

.v-container.fluid {
	position: relative !important;
	overflow: visible !important;
}

/* App bar positioning is handled by Vuetify with the 'app' prop */

/* Footer should be at bottom of content */
.v-footer {
	position: relative !important;
	margin-top: auto !important;
}
</style>